/**
 * Track analytics event (GA4)
 * Usage: ui8-track-event="Category,Action,Label,Value"
 * Usage: ui8-track-event="Category,Action,,Value" (ignore label)
 */
angular.module("UI8.directives").directive("ui8TrackEvent", [
  "$window",
  function ($window) {
    return {
      restrict: "A",
      link: function (scope, elem) {
        scope.$on("$destroy", function () {
          elem.off("click touchstart");
        });

        elem.on("click touchstart", function () {
          if (!$window.gtag) return;

          var parts = $(this)
            .attr("ui8-track-event")
            .split(",")
            .map(function (el) {
              return el.trim() || undefined;
            });

          return $window.gtag("event", parts[1] || "click", {
            event_category: parts[0],
            event_label: parts[2],
            value: parts[3] ? Number(parts[3]) : undefined,
          });
        });
      },
    };
  },
]);
